/** Minefield background maps (files in /public). */
export const REGION_ASSETS = {
  hormuz: '/straight_of_hormuz.jpg',
  hormuz_lol: '/straight_of_hormuz_butthole.png',
}

export const REGION_OPTIONS = [
  { id: 'hormuz', label: 'Strait of Hormuz' },
  { id: 'hormuz_lol', label: 'Strait of Hormuz (LOL)' },
]
